// index.html loads Stripe.js (https://js.stripe.com/v3/) as a blocking
// <script> tag, so window.Stripe is normally ready before the app mounts.
// But on a slow connection the app can finish mounting before that script
// tag actually finishes downloading — a plain `typeof window.Stripe ===
// 'function'` check at that moment reads as "failed to load" even though
// it's still legitimately on its way in. This waits for the existing tag's
// load event (or injects one if it's somehow missing) before giving up.
const STRIPE_JS_SRC = 'https://js.stripe.com/v3/';
const DEFAULT_TIMEOUT_MS = 8000;

function ensureStripeJsLoaded(timeoutMs = DEFAULT_TIMEOUT_MS) {
    if (typeof window.Stripe === 'function') {
        return Promise.resolve(true);
    }

    return new Promise((resolve) => {
        let settled = false;
        const finish = (ok) => {
            if (settled) return;
            settled = true;
            resolve(ok);
        };

        const timer = setTimeout(() => {
            finish(typeof window.Stripe === 'function');
        }, timeoutMs);

        const onLoad = () => {
            clearTimeout(timer);
            finish(typeof window.Stripe === 'function');
        };
        const onError = () => {
            clearTimeout(timer);
            finish(false);
        };

        const existing = document.querySelector(`script[src="${STRIPE_JS_SRC}"]`);
        if (existing) {
            existing.addEventListener('load', onLoad, { once: true });
            existing.addEventListener('error', onError, { once: true });
        } else {
            const script = document.createElement('script');
            script.src = STRIPE_JS_SRC;
            script.addEventListener('load', onLoad, { once: true });
            script.addEventListener('error', onError, { once: true });
            document.head.appendChild(script);
        }
    });
}

export default ensureStripeJsLoaded;


// WEBPACK FOOTER //
// ./src/lib/load-stripe-js.js